module.exports = __webpack_public_path__ + "assets/img/delete.396cb429.svg";